module.exports = __webpack_public_path__ + "img/shanghaione.0fea8e98.jpg";